<template>
    <el-dialog :title="$t('account.component_ChangePassword_dialog_title')" :visible.sync="show" destroy-on-close @close="closeDialogEvent" width="440px" top="20px">  
        <div class="change-password-form-content">
            <el-form ref="changePasswordForm" :rules="formRules" :model="form">
                <el-form-item prop="old">
                    <el-input type="password" v-model="form.old" :placeholder="$t('account.component_ChangePassword_dialog_placeholder_1')" autocomplete="off" show-password></el-input>
                </el-form-item>
                <el-form-item prop="new">
                    <el-input type="password" v-model="form.new" :placeholder="$t('account.component_ChangePassword_dialog_placeholder_2')" autocomplete="off" show-password></el-input>
                </el-form-item>
                <el-form-item prop="confirm">
                    <el-input type="password" v-model="form.confirm" :placeholder="$t('account.component_ChangePassword_dialog_placeholder_3')" autocomplete="off" show-password></el-input>
                </el-form-item>
            </el-form>
            <div class="actions text-center" style="margin-top: 50px;">
                <el-button round plain size="small" @click="show = false">{{$t('account.component_ChangePassword_dialog_btn_1')}}</el-button>
                <el-button round type="primary" size="small" style="margin-left:20px;" :loading="loading" @click="submitChangePassword">{{$t('account.component_ChangePassword_dialog_btn_2')}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { Base64 } from "js-base64";
import { mapState } from 'vuex';
import { userApi } from '@/utils/api';
export default {
    name: 'ChangePassword',
    data(){
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('account.component_ChangePassword_data_message_1')));
            } else{ 
                let rst = /^(?=.*[a-z])(?=.*\d).{6,20}$/.test(value); // ^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]{6,20})$
                if (rst) {
                    callback();
                }else{
                    callback(new Error(this.$t('account.component_ChangePassword_data_message_2')));
                }
            }
        };
        const validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('account.component_ChangePassword_data_message_3')));
            }else if(value !== this.form.new){
                callback(new Error(this.$t('account.component_ChangePassword_data_message_4')));
            }else{
                callback();
            }
        };
        return {
            show: false,
            loading: false,
            form: {
                old: '',
                new: '',
                confirm: '',
            },
            formRules: {
                old: [{ required: true, message: this.$t('account.component_ChangePassword_data_formRules_message'), trigger: 'blur' }],
                new: [{ validator:validatePass, trigger: 'blur' }],
                confirm: [{ validator:validatePass2, trigger: 'blur' }]
            }
        }
    },
    computed: {
        ...mapState({
			userInfo: state => state.user.userData,
		}),
    },
    methods:{
        setShow(val){
            this.show = val;
        },
        closeDialogEvent(){
            this.form = {
                old: '',
                new: '',
                confirm: '',
            };
            this.loading = false;
            
        },
        submitChangePassword(){
            this.$refs['changePasswordForm'].validate((valid) => {
                if (valid) {
                    //成功
                    // console.log('success');
                    let url = userApi.setPassword;
                    let postData={
                        newPassword: Base64.encode(this.form.new),
                        oldPassword: Base64.encode(this.form.old)
                    };
                    this.loading = true;
                    this.$ajax.post(url,postData).then(res=>{
                        if(res.status === 200){
                            this.$message.success(this.$t('account.component_ChangePassword_method_submitChangePassword_message_1'));
                            this.show = false;
                        }
                    }).finally(()=>{
                        this.loading = false;
                    });
                    
                } else {
                    return false;
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.change-password-form-content{
    padding: 0 60px;
}
</style>
